import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Region from "./Region";

import { setRegion } from "../redux/actions/regions";

const StyledDestinations = styled.div`
  position: relative;
  h2 {
    margin: 0 auto 20px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    @media all and (max-width: 700px) {
      font-size: 17px;
    }
  }
  .regions {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: flex-end;
    @media all and (max-width: 700px) {
      flex-wrap: wrap;
    }
    &.has-errors {
      border: 1px solid #ff3a3a;
      box-shadow: 0 0 5px 0px rgba(255, 58, 58, 0.3);
      padding: 10px 0;
    }
  }
  .error-found {
    color: #ff3a3a;
    font-size: 13px;
    font-weight: lighter;
    background: #ffe2e2;
    text-align: center;
    padding: 13px 0;
  }
`;

const Destinations = ({
  imgPrefix,
  setregion,
  copy,
  activeRegion,
  regionError,
  ...rest
}) => {
  const hasErrors =
    rest.countryerror ||
    rest.oftenerror ||
    rest.preferenceerror ||
    rest.purposeerror ||
    regionError;
  return (
    <StyledDestinations>
      <h2>{copy.destinations.title}</h2>
      {hasErrors && <p className="error-found">{copy.destinations.error}</p>}
      <div className={`regions${regionError ? " has-errors" : ""}`}>
        <Region
          onChange={e => {
            setregion(e.target.name);
            window.dataLayer.push({
              category: "Email_Submit",
              event: "Select_Destination",
              label: "Europe"
            });
          }}
          {...{ imgPrefix }}
          value={activeRegion}
          checkId="Europe"
          img="/images/europe.png"
          copy={copy.destinations.eu}
        />
        <Region
          onChange={e => {
            setregion(e.target.name);
            window.dataLayer.push({
              category: "Email_Submit",
              event: "Select_Destination",
              label: "US"
            });
          }}
          {...{ imgPrefix }}
          value={activeRegion}
          checkId="US"
          img="/images/us.png"
          copy={copy.destinations.us}
        />
      </div>
    </StyledDestinations>
  );
};

Destinations.defaultProps = {
  activeRegion: ""
};

Destinations.propTypes = {
  copy: PropTypes.objectOf(PropTypes.object).isRequired,
  imgPrefix: PropTypes.string.isRequired,
  setregion: PropTypes.func.isRequired,
  activeRegion: PropTypes.string,
  regionError: PropTypes.bool.isRequired
};
const mapDispatchToProps = dispatch => ({
  setregion: val => dispatch(setRegion(val))
});

const mapStateToProps = state => ({
  ...state.regions,
  ...state.questions
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Destinations);
